import type { PublishEligibility } from './types';

export type PublishAction = 'pro_gate' | 'open_dialog' | 'hidden';

/** The button is hidden only when there is nothing to send. Every other state
 *  keeps it clickable: free users get the upgrade dialog, PRO users get the
 *  send dialog which explains reconnect/quota in place. Never a disabled
 *  button — same click-time-gate rule as bulk export. */
export function resolvePublishAction({
  isPro,
  eligibility,
}: {
  isPro: boolean;
  eligibility: PublishEligibility;
}): PublishAction {
  if (eligibility === 'not_rendered') return 'hidden';
  if (!isPro) return 'pro_gate';
  return 'open_dialog';
}
